import { Box, Flex, Image } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

import { PointingGuy } from '../../../../assets/Images';

export type StepperSidebarItem = {
  key: string;
  node: ReactNode;
};

type StepperLayoutProps = {
  header: ReactNode;
  children: ReactNode;
  sidebarItems: StepperSidebarItem[];
};

const StepperLayout = ({ header, children, sidebarItems }: StepperLayoutProps) => (
  <Flex flexDirection={{ base: 'column', lg: 'row' }} mx={{ base: 4, md: 0 }}>
    <Box
      w="8%"
      position="relative"
      alignSelf="stretch"
      bgGradient="linear(to-b, grayBackground, white)"
      display={{ base: 'none', lg: 'block' }}
      roundedTopRight="24px"
      _before={{
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: '100%',
        width: '100vw',
        bgGradient: 'linear(to-b, grayBackground, white)',
      }}
    >
      <Image
        w="120px"
        src={PointingGuy}
        alt=""
        zIndex={1}
        mt={-2}
        position="absolute"
        top="25px"
        right="-52px"
      />
    </Box>
    <Box bgColor="white" flex={1} px={{ base: 2, xl: '50px' }}>
      {header}
      {children}
    </Box>
    <Flex
      position="relative"
      bgGradient="linear(to-b, grayBackground, white)"
      p={4}
      pb={{ base: 4, md: 24 }}
      roundedTopLeft="24px"
      flexDir={{ base: 'column', md: 'row', lg: 'column' }}
      flexWrap={{ md: 'wrap', lg: 'nowrap' }}
      justifyContent={{ md: 'center', lg: 'flex-start' }}
      w={{ base: 'full', lg: '26%' }}
      mr={{ lg: 4 }}
      gap={4}
      _after={{
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: '100%',
        width: '100vw',
        bgGradient: 'linear(to-b, grayBackground, white)',
      }}
    >
      {sidebarItems.map((item) => (
        <Box
          key={item.key}
          flex={{ md: '1 1 280px', lg: 'none' }}
          maxW={{ md: '320px', lg: 'none' }}
        >
          {item.node}
        </Box>
      ))}
    </Flex>
  </Flex>
);

export default StepperLayout;
